import styled from "styled-components";

export default function OrderInvoiceBottom({ children }) {
  return (
    <Block>{children}</Block>
  )
}

const Block = styled.div`
  padding-top: calc(100vw * (33 / 375));
  padding-left: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (17 / 375));
`;